import React from 'react';

/** Enveloppe scrollable : les tableaux larges défilent sans casser la page. */
export const TableWrap = ({ children, className = '' }) => (
  <div className={`scrollbar-slim w-full overflow-x-auto ${className}`}>{children}</div>
);

export const Table = ({ children, className = '' }) => (
  <table className={`w-full border-collapse ${className}`}>{children}</table>
);

export const THead = ({ children }) => (
  <thead className="bg-surface-subtle">{children}</thead>
);

export const TH = ({ children, className = '', align = 'start', ...props }) => {
  const alignment = { start: 'text-start', center: 'text-center', end: 'text-end' }[align] || 'text-start';
  return (
    <th
      className={`border-b border-line px-4 py-2.5 text-2xs font-semibold uppercase text-ink-subtle ${alignment} ${className}`}
      {...props}
    >
      {children}
    </th>
  );
};

export const TBody = ({ children }) => (
  <tbody className="divide-y divide-line">{children}</tbody>
);

/** Pas de zébrage : la densité vient de l'espacement, pas des fonds alternés. */
export const TR = ({ children, className = '', ...props }) => (
  <tr className={`transition-colors duration-100 hover:bg-surface-hover ${className}`} {...props}>
    {children}
  </tr>
);

export const TD = ({ children, className = '', align = 'start', ...props }) => {
  const alignment = { start: 'text-start', center: 'text-center', end: 'text-end' }[align] || 'text-start';
  return (
    <td className={`px-4 py-2.5 text-sm text-ink ${alignment} ${className}`} {...props}>
      {children}
    </td>
  );
};
